import { useState, useEffect } from 'react';
import apiClient from '../utils/api';
import { LEGAL_PAGE_BY_KEY } from '../config/legalPages';
import { renderTermsMarkdown } from './TermsPage';

const STATIC_TERMS_FALLBACK = '/terms-of-service.md';

const LegalPage = ({ pageKey, setPage }) => {
  const meta = LEGAL_PAGE_BY_KEY[pageKey];
  const [bodyHtml, setBodyHtml] = useState('');
  const [loadError, setLoadError] = useState('');
  const [title, setTitle] = useState(meta?.title || 'Legal');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!meta) {
      setLoadError('Page not found.');
      return undefined;
    }

    let cancelled = false;

    const loadStaticTermsFallback = () =>
      fetch(STATIC_TERMS_FALLBACK, { cache: 'no-store' })
        .then((r) => {
          if (!r.ok) throw new Error(`Could not load ${meta.title}.`);
          return r.text();
        })
        .then((text) => {
          if (!cancelled) {
            setTitle(meta.title);
            setBodyHtml(renderTermsMarkdown(text));
          }
        });

    apiClient
      .getLegalPage(meta.slug)
      .then((res) => {
        if (cancelled) return;
        const row = res.data;
        setTitle(row.title || meta.title);
        setBodyHtml(renderTermsMarkdown(row.body || ''));
      })
      .catch(async (err) => {
        if (cancelled) return;
        if (meta.slug === 'terms-of-service' && err?.status === 404) {
          try {
            await loadStaticTermsFallback();
            return;
          } catch (fallbackErr) {
            setLoadError(fallbackErr.message || `Could not load ${meta.title}.`);
            return;
          }
        }
        setLoadError(err.message || `Could not load ${meta.title}.`);
      });

    return () => {
      cancelled = true;
    };
  }, [meta, pageKey]);

  if (!meta) {
    return (
      <div className="container terms-page">
        <p className="terms-loading">Page not found.</p>
      </div>
    );
  }

  return (
    <div className="container terms-page">
      <button type="button" className="btn btn-ghost btn-sm" style={{ marginBottom: '1rem' }} onClick={() => setPage('home')}>
        <i className="fas fa-arrow-left"></i> Back
      </button>
      {loadError ? (
        <p className="terms-loading">{loadError}</p>
      ) : bodyHtml ? (
        <>
          {!bodyHtml.includes('<h1') && <h1 className="section-title" style={{ marginBottom: '1.5rem' }}>{title}</h1>}
          <div className="terms-body" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
        </>
      ) : (
        <p className="terms-loading">Loading {meta.title}…</p>
      )}
    </div>
  );
};

export default LegalPage;
